(function($){ $(function(){
    
    $('#sortBy').selectBox({
    	menuTransition: 'slide',
		menuSpeed: 'fast'
	});

    $('#sortBy').bind('change', function () {
        var url = $(this).val(); // get selected value
        if (url) { // require a URL
            window.location = url; // redirect
        }
    });
    
    $(".fader").hover(
		function () {
			$(this).stop(true,true).fadeTo('slow', 0.75);
		},
		function () {
			$(this).stop(true,true).fadeTo('fast', 1.0);
		}
	);
	
	//cache nav  
    var nav = $("#mainNav");  

    //add indicators and hovers to submenu parents  
    nav.find("li").each(function() {  
        if ($(this).find("ul").length > 0) {
            //show subnav on hover  
            $(this).mouseenter(function() {  
                $(this).find("ul").stop(true, true).fadeIn('fast');  
            });  

            //hide submenus on exit  
            $(this).mouseleave(function() {  
                $(this).find("ul").stop(true, true).fadeOut('fast');  
            });  
        }  
    });

	$("a.group").fancybox({
		'transitionIn'	:	'elastic',
		'transitionOut'	:	'elastic',
		'overlayColor'  :  '#000',
		'speedIn'		:	250, 
		'speedOut'		:	100, 
		'overlayShow'	:	true
	});
	
	$('#searchInput').bind('focus', function(){ 
		$(this).animate({width: '175'}, 'fast','easeInSine');
	});
	$('#searchInput').bind('blur', function(){
		if( $(this).val().length === 0 ) {
			$(this).animate({width: '135'}, 'fast','easeInSine');
		}
	});

}); })(jQuery)